import { computed, defineComponent, PropType } from 'vue';

import Attachments from '@/components/attachments/attachments';
import MediaAttachmentRepository from '@/repositories/media-attachment-repository';
import useRootStore from '@/store/root';
import { Attachment } from '@/types/Attachment';
import { Media$Details } from '@/types/Media';

export default defineComponent({
  props: {
    origin: { type: Object as PropType<Media$Details>, required: true },
  },
  components: {
    Attachments,
  },
  setup(props) {
    const store = useRootStore();
    const repository = new MediaAttachmentRepository(props.origin);

    const descriptions = store.mediaAttachments[props.origin.type] || [];

    const attachments = computed<Attachment[]>({
      get: () => props.origin.attachments || [],
      set: (val: Attachment[]) => {
        props.origin.attachments = val;
      },
    });

    return () => (
      <div>
        <div>
          <l10n group="media" tkey="attachment__info" />
        </div>
        <Attachments
          class="bom"
          descriptions={descriptions}
          repository={repository}
          vModel={[attachments.value, 'list']}
        />
      </div>
    );
  },
});
